<app-listing-summary-desktop *ngIf="!isBrowserMode || screenSize >= SCREEN_SIZE.TABLET_LANDSCAPE_UP"
    [listing]="listing" [hasNextListings]="hasNextListings"
    [hasCopiedText]="hasCopiedText"
    [mortgagePaymentAmount]="mortgagePaymentAmount"
    [showMap]="showMap"
    [sessionEmail]="sessionEmail"
    [isEdmontonBoard]="isEdmontonBoard"
    [showExpandedGalleryView]="showExpandedGalleryView"
    [isMortgageApplicable]="isMortgageApplicable"
    [disableSellersLeadForm]="disableSellersLeadForm"
    (nextListingClicked)="nextListingClicked.emit($event)"
    (homeEstimateLinkClick)="homeEstimateLinkClick.emit($event)"
    (previousListingClicked)="previousListingClicked.emit($event)"
    (showContactAgentClicked)="showContactAgentClicked.emit($event)"
    (showScheduleViewingClicked)="showScheduleViewingClicked.emit($event)"
    (toggleExpandedGalleryView)="toggleExpandedGalleryView.emit($event)"
    (showOffmarketCTAClicked)="showOffmarketCTAClicked.emit($event)"
    (toggleMap)="toggleMap.emit($event)"
    ></app-listing-summary-desktop>

<app-listing-summary-mobile *ngIf="!isBrowserMode || screenSize < SCREEN_SIZE.TABLET_LANDSCAPE_UP"
    [listing]="listing" [hasNextListings]="hasNextListings"
    [sessionEmail]="sessionEmail"
    [hasCopiedText]="hasCopiedText"
    [isEdmontonBoard]="isEdmontonBoard"
    [mortgagePaymentAmount]="mortgagePaymentAmount" [showMap]="showMap"
    [isMortgageApplicable]="isMortgageApplicable"
    [disableSellersLeadForm]="disableSellersLeadForm"
    [showExpandedGalleryView]="showExpandedGalleryView"
    (nextListingClicked)="nextListingClicked.emit($event)"
    (homeEstimateLinkClick)="homeEstimateLinkClick.emit($event)"
    (previousListingClicked)="previousListingClicked.emit($event)"
    (showContactAgentClicked)="showContactAgentClicked.emit($event)"
    (showScheduleViewingClicked)="showScheduleViewingClicked.emit($event)"
    (toggleExpandedGalleryView)="toggleExpandedGalleryView.emit($event)"
    (showOffmarketCTAClicked)="showOffmarketCTAClicked.emit($event)"
    (toggleMap)="toggleMap.emit($event)"
    class="hide-on-tablet-landscape-up"></app-listing-summary-mobile>
